// extracted by mini-css-extract-plugin
module.exports = {"Container":"_3HCTE","Inline":"_1GX4s","Avatar":"_36PV9","Seller":"_2a41F","Header":"_2XEcy","Since":"_3IeoS"};